module.exports = __webpack_public_path__ + "static/media/logo_dark.af1a5c89.svg";